<template>
  <div class="outer-wrapper">
    <div class="editor-wrapper" v-show="!detailShow">
      <div class="title-wrapper">
        <a :href="'/dayProjectList/'+(parseInt(dayDelta)-1)" v-if="(dayDelta-1>=0)" class="arrow left-a"><van-icon name="arrow-left" /></a>
        <span>日订单明细({{currentDate}})</span>
        <a :href="'/dayProjectList/'+(parseInt(dayDelta)+1)"><van-icon name="arrow" class="arrow right-a"/></a>
      </div>
      <van-search placeholder="请输入搜索关键词" v-model="keyword" @search="onSearch" />
      <van-list
        v-model="itemTable.loading"
        :finished="itemTable.finished"
        finished-text="没有更多了"
        :error.sync="itemTable.error"
        error-text="请求失败，点击重新加载"
        @load="onLoad"
      >
        <van-cell
            v-for="item in itemTable.tivdata"
            :key="item.display_no+'day'"
            is-link
            :url="'/contract_stat/'+item.display_no"
          >
          <template slot="title">
            <a :href="'/contract_stat/'+item.display_no">{{projectDisplayNoAbbr(item.display_no)}}</a>
            <span> - ￥{{item.final_price}}元</span>
          </template>
          <template slot="label">
            <p>{{item.company_name}}</p>
            <p>{{(item.remark&&JSON.parse(item.remark).customer)?('备注：'+JSON.parse(item.remark).customer):''}}</p>
          </template>
          <span class="cell-item">{{item.create_time}}</span>
          </van-cell>
      </van-list>
    </div>
    <!-- <div class="report-wrapper" v-show="detailShow">
      <van-nav-bar title="订单详情" left-text="返回" left-arrow @click-left="onClickBack" fixed></van-nav-bar>
      <p
        class="detail-title"
      >{{currentItem.company_name}}</p>
      <van-panel title="标准中文名称：" desc status>
        <div class="d-wrapper">
          <p>{{currentItem.standard_name_ch}}</p>
        </div>
      </van-panel>
      <van-panel title="标准英名称：" desc status>
        <div class="d-wrapper">
          <p>{{currentItem.standard_name_en}}</p>
        </div>
      </van-panel>
      <van-cell title="发布日期" :value="currentItem.standard_date" />
      <van-cell title="实施日期" :value="currentItem.standard_date_do" />
      <van-cell
        title="当前状态"
        :value="currentItem.ifValid"
        :value-class="calStat(currentItem.ifValid)"
      />
      <van-cell title="详情" value="点击下载标准" is-link @click="linkTo(currentItem.file_url)" />
    </div> -->
  </div>
</template>
<script>
let userToken = localStorage.getItem("current_user_token");
let authData = JSON.parse(localStorage.getItem("authData"));
import { textTrans } from "@/mixins/TextTrans.js";

import dayjs from 'dayjs'

function itemTableFac() {
  return {
    loading: false,
    finished: false,
    error: false,
    Tpage: {
      currentPage: 1,
      currentSize: 20
    },
    no_data_text: "",
    totalItems: 0,
    tivdata: [
    ]
  };
}

export default {
  name: "dayProjectList",
  props: {
    dayDelta:{
      style:String,
      default(){
        return '0';
      }
    },
  },
  components: {},
  mixins: [textTrans],
  data() {
    return {
      itemTable: itemTableFac(),
      detailShow: false,
      currentItem: {},
      keyword: "",
    };
  },
  computed:{
    currentDate:function(){
      let tmp = dayjs().subtract(parseInt(this.dayDelta), 'day');
      return tmp.format('YYYY-MM-DD');
    }
  },
  methods: {
    linkTo(url) {
      window.open(this.$fileUrlFac(url, authData.sfileRight));
    },
    onSearch() {
      this.itemTable = itemTableFac();
      this.onLoad();
    },
    onLoad() {
      this.itemTable.loading = true;
      this.$axios
        .post(this.$url + "/ask_list_data", {
          page: this.itemTable.Tpage,
          userToken: userToken,
          ask_data: "dayProjectList",
          dayDelta:this.dayDelta,
          selected_list: [],
          keyword: this.keyword
        })
        .then(response => {
          for (let ele of response.data.res_record) {
            this.itemTable.tivdata.push(ele);
          }
          if (
            response.data.res_record.length < this.itemTable.Tpage.currentSize
          ) {
            this.itemTable.finished = true;
          }
          this.itemTable.loading = false;
          this.itemTable.Tpage.currentPage++;
        });
    },
    chooseItem(val) {
      this.currentItem = val;
      this.detailShow = true;
    },
    onClickBack() {
      this.detailShow = false;
    }
  }
};
</script>
<style scoped>
.inner-wrapper {
  width: 100%;
  background: #f7f7f7;
  min-height: 20rem;
}

.title-wrapper {
  text-align: center;
  font-size: 0.8rem;
  color: #999;
  padding: 1rem;
  background: #fff;
  border-bottom: 1px solid #f6f6f6;
}

.editor-wrapper {
  width: 100%;
}
.cell-item {
  margin-left: 0.6rem;
}
.d-wrapper {
  padding: 0.5rem 1rem;
  text-align: center;
  font-size: 0.6rem;
}

.cell-label {
  width: 180%;
  color: #666;
}
.detail-title {
  text-align: center;
  font-size: 0.8rem;
  padding: 0.5rem 0;
}
.c-green {
  color: rgb(33, 99, 33);
}

.c-red {
  color: rgb(173, 28, 28);
}

.c-blue {
  color: rgb(20, 59, 92);
}

.c-no {
  color: #999;
}

.c-tag{
  position: relative;
  bottom: 0.2rem;
  margin-right:0.1rem;
}

.arrow{
  position: relative;
  top:0.1rem;
  font-size: 1rem;
}

.left-a{
  float: left;
}
.right-a{
  float: right;
}
</style>